import { render, staticRenderFns } from "./TrendingPreview.vue?vue&type=template&id=43140bce&"
import script from "./TrendingPreview.vue?vue&type=script&lang=js&"
export * from "./TrendingPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports